module.exports = __webpack_public_path__ + "img/admin-2012-meeting.32c86de2.jpg";